import type {
    CreatureVehicleSpeedAdoptionInput,
    CreatureVehicleSpeedAdoptionResult,
    MountRestrictedSpeedName,
    VehicleSpeedSlot,
} from '../types';
import { MOUNT_RESTRICTED_SPEEDS } from './creature-mount-speed-restriction';

function slotValue(slot: VehicleSpeedSlot): number | null {
    if (slot === null || slot === undefined) return null;
    if (typeof slot === 'number') return slot;
    return slot.pre_mount ?? slot.total ?? null;
}

/** Adopt resolved vehicle speeds after status/query discovery has selected the vehicle. */
export function adoptCreatureVehicleSpeeds(input: CreatureVehicleSpeedAdoptionInput): CreatureVehicleSpeedAdoptionResult {
    return Object.fromEntries(MOUNT_RESTRICTED_SPEEDS.map((speed) => {
        const variableName = `speed_${speed}` as const;
        let vehicleBase = slotValue(input.vehicleSlots[speed] ?? null)
            ?? input.vehicleLegacyBase[variableName]
            ?? input.vehicleInventoryBase[variableName]
            ?? 0;
        if (vehicleBase === 0 && (input.vehicleIsInventory || !input.vehicleHasComputedSpeedsBucket)) {
            vehicleBase = input.vehicleLayerScores[variableName] ?? 0;
        }
        const pilotPreMount = input.pilotTotals[speed] ?? 0;
        return [speed, {
            total: vehicleBase,
            base: 0 as const,
            locked: true as const,
            ...(pilotPreMount !== 0 ? { pre_mount: pilotPreMount } : {}),
        }];
    })) as CreatureVehicleSpeedAdoptionResult;
}
